import React from 'react';

const Loader = (props) =>{
  return (
  <div className="loader" style={{zIndex: '10000'}}>
      <svg x="0px" y="0px" width="39px" height="25px" viewBox="0 0 39.04 25.25">
      <path id="my" d="M39.04,19.42c0,0.31-0.04,2.68-1.69,4.34c-0.97,0.98-2.3,1.49-3.86,1.49h-0.48v0
      	c-1.11,0-2.2-0.19-3.25-0.57c0,0-0.44-0.22-0.49-0.24c-0.04-0.02-0.09-0.05-0.13-0.07c-0.09-0.05-0.19-0.1-0.29-0.16
      	c-0.1-0.06-0.21-0.13-0.32-0.19c-0.11-0.07-0.22-0.14-0.33-0.22c-0.11-0.08-0.22-0.16-0.33-0.24c-0.11-0.08-0.21-0.17-0.32-0.25
      	c-0.1-0.08-0.2-0.17-0.3-0.25c-0.07-0.06-0.13-0.12-0.19-0.18l1.68-1.82c0.01,0.01,0.02,0.01,0.03,0.02
      	c0.08,0.05,0.17,0.1,0.26,0.14c0.09,0.05,0.18,0.09,0.27,0.14c0.09,0.04,0.18,0.09,0.27,0.12c0.74,0.31,2.21,0.79,3.46,0.8v0h0.46
      	c1.09,0,1.76-0.38,2.18-1.24c0.36-0.74,0.38-1.53,0.39-1.6l0-0.01l0,0v-1.74c-0.26,0.18-0.53,0.35-0.81,0.49l0,0
      	c-1.05,0.56-2.26,0.85-3.49,0.85c-1.49,0-2.93-0.42-4.13-1.22c-1.78-1.16-2.84-3.15-2.84-5.32l0-7.83l2.98-1.41v9.31
      	c0.02,1.13,0.57,2.16,1.48,2.76c0.7,0.47,1.6,0.73,2.5,0.73c0.77,0,1.51-0.18,2.15-0.53l0,0c1.31-0.68,2.15-2.11,2.15-3.66V1.65
      	l2.95-1.4h0.02v11.77h0c0,0.06,0,0.13-0.01,0.19h0.01V19.42z M22.89,18.8h-2.98V5.97c0-0.97-0.52-1.87-1.3-2.38
      	c-0.6-0.4-1.31-0.61-2.08-0.61c-0.65,0-1.28,0.16-1.82,0.45l0,0C13.6,4,12.88,5.22,12.88,6.53v6.3l-2.98,1.38V6.53
      	c0-0.29,0.02-0.59,0.06-0.87C9.88,4.82,9.42,4.05,8.74,3.6l0.01-0.01C8.15,3.2,7.39,2.98,6.63,2.98c-0.65,0-1.28,0.16-1.82,0.45l0,0
      	C3.69,4,2.98,5.22,2.98,6.53v12.26L0,18.8h0V6.53c0-2.46,1.32-4.67,3.45-5.76l0,0C4.42,0.27,5.51,0,6.63,0
      	c1.35,0,2.65,0.38,3.73,1.11c0.45,0.29,0.85,0.65,1.2,1.05c0.5-0.56,1.11-1.03,1.8-1.39l0,0C14.32,0.27,15.42,0,16.54,0
      	c1.35,0,2.67,0.38,3.76,1.11c1.63,1.06,2.6,2.88,2.6,4.86V18.8z" fill="#1FDAC8" fillRule="evenodd" clipRule="evenodd"/>
      </svg>
      <div className="loader__animation">
          <svg className="loader__circular">
              <circle className="loader__path" cx="80" cy="80" r="20" fill="none" strokeWidth="2" strokeMiterlimit="10"></circle>
          </svg>
      </div>
  </div>
  )
};

export default Loader;


// WEBPACK FOOTER //
// ./src/_app/drafts/components/Loader.jsx